import { render } from "./DetailProperties.vue?vue&type=template&id=4f8bad4a"
import script from "./DetailProperties.vue?vue&type=script&lang=js"
export * from "./DetailProperties.vue?vue&type=script&lang=js"

import "./DetailProperties.vue?vue&type=style&index=0&id=4f8bad4a&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__